import queueItemStatuses, { QueueItemStatus } from 'common/helpers/constants/queueItemStatuses'


type QueueItem = {
  status: QueueItemStatus[]
  products: number[]
}

type Count = {
  count: number
  activeCount: number
}

/**
 * Counts queue items
 */
const getQueueProductsCount = <T extends QueueItem[]>(queueItems: T): Count => {
  const itemActiveStatuses = [
    queueItemStatuses.product,
    queueItemStatuses.free,
    queueItemStatuses.redeemed,
    queueItemStatuses.unavailable,
  ]

  let count = 0
  let activeCount = 0

  queueItems.forEach(({ status }) => {
    status.forEach((item) => {
      if (itemActiveStatuses.includes(item)) {
        activeCount++
      }
      if (item === queueItemStatuses.product) {
        count++
      }
    })
  })

  return { count, activeCount }
}


export default getQueueProductsCount
